export default "__VITE_ASSET__DQu799EU__"